import { Link } from "@tanstack/react-router";

import { MONOLITH_BOARD_STYLE } from "@/components/dashboard/monolithBoardStyle";
import { cn } from "@/lib/classNames";

import { AdminToolIcon } from "./adminToolIcons";
import { ADMIN_TOOLS } from "./adminTools";

export default function AdminHubPage() {
  return (
    <div className="mx-auto max-w-4xl px-5 py-12 pb-24 sm:px-8">
      <header className="border-b-[3px] border-neutral-950 pb-10">
        <p className="text-[11px] uppercase tracking-[0.28em] text-neutral-600">Internal review</p>
        <h1 className="mt-4 text-4xl font-bold leading-tight tracking-tight [font-family:var(--color-lab-display),system-ui,sans-serif] sm:text-5xl">
          Developer hub
        </h1>
        <p className="mt-4 max-w-2xl text-lg leading-relaxed text-neutral-800">
          Use the sidebar to jump between tools, or open a destination below.
        </p>
      </header>

      <ul className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {ADMIN_TOOLS.map((tool) => (
          <li key={tool.href}>
            <Link
              to={tool.href}
              className={cn(
                "group flex h-full flex-col rounded-[28px] p-6 transition-transform hover:-translate-y-0.5 sm:p-8",
                MONOLITH_BOARD_STYLE.panelClassName,
              )}
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center border-2 border-neutral-950 bg-[#fff2d9] text-neutral-950">
                <AdminToolIcon id={tool.icon} className="h-6 w-6" aria-hidden />
              </span>
              <span className="mt-4 text-lg font-bold uppercase tracking-tight [font-family:var(--color-lab-display),system-ui,sans-serif]">
                {tool.label}
              </span>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-neutral-800">{tool.description}</p>
              <p className="mt-6 text-[11px] font-semibold uppercase tracking-[0.24em] text-neutral-950 underline decoration-2 underline-offset-4 group-hover:text-neutral-700">
                Open tool →
              </p>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
